import * as Config from '../../config';
import Locale from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class DoorLeftOpen extends AlertLogic {
    static contentCategories = [ ContentCategories.SYSTEM_INFO ];
    static type:AlertType|AlertType[] = AlertType.DoorLeftOpen;
    static title = Locale.gettext('Door Left Open');

    getInfo(timeZone?: string): AlertInfo {
        const alert = this.alert;
        const config = this.allConfigs;
        
        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(timeZone);

        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Check Door'),
            cardDescription: this.locale.gettext('The Attendant door of module %d may have been left open',
                alertData.ModuleNumber
            ),
            cardIllustration: 'report_frightened',
            detailIcon: "sensor-door",
            detailTitle: this.locale.gettext('Check Door'),
            detailDescription: this.locale.gettext('The Attendant door of module %d may have been left open. It appears to have been open for more than 3 hours.',
                alertData.ModuleNumber
            ),
            detailDescription2: this.locale.gettext('Please check and ensure the door to your Attendant is fully closed and latched.'),
            moreButton: true,
            actionButtonTitle: false,
            resolveSummary: this.locale.gettext('Door has been closed')
        });
        alertInfo.contentCategories = DoorLeftOpen.contentCategories;
        return alertInfo;
    }

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device:Partial<Config.DeviceConfig> = config?.Config?.Controllers[ 0 ];
        device = device || { UUID: UUID.generate(), Name: "Device 1" };

        return new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: device.UUID,
            bodyUuid: null,
            type: type,
            data: {
                ControllerNumber: 1,
                ModuleNumber: "1",
                DoorOpenSinceTime: 1234,
            }
        });
    }
}